import * as server from "Shared/server";
import { pathCombine } from "Shared/url";
import { searchPageUrl } from "Shared/known-urls";
import * as searchHistory from "./search-history";
import { recipeOverviewPageUrl } from "Shared/known-urls";
import { cancelPendingViewItemListTracking, debounceQuickSearchTracking } from "../TrackingInformation/index";
export const SHOW_LISTSEARCH = "SHOW_LISTSEARCH";
export const SHOW_QUICKSEARCH = "SHOW_QUICKSEARCH";
export const HIDE_QUICKSEARCH = "HIDE_QUICKSEARCH";
export const UPDATE_QUICKSEARCH_TEXT = "UPDATE_QUICKSEARCH_TEXT";
export const UPDATE_QUICKSEARCH_COMPLETIONS = "UPDATE_QUICKSEARCH_COMPLETIONS";
export const UPDATE_SELECTED_QUICKSEARCH_COMPLETION = "UPDATE_SELECTED_QUICKSEARCH_COMPLETION";
export const UPDATE_QUICKSEARCH_CART = "UPDATE_QUICKSEARCH_CART";
export const CLEAR_QUICKSEARCH_CART = "CLEAR_QUICKSEARCH_CART";
export const CLOSE_QUICKSEARCH = "CLOSE_QUICKSEARCH";
export const SEARCH_HISTORY_LIST_ID = "searchHistory";
export const POPULAR_SEARCHES_LIST_ID = "popular";
export const SUGGESTIONS_LIST_ID = "suggestions";
export const PRODUCT_LIST_ID = "products";
const autocompletionCount = 5;
const searchHistoryCount = 3;
let lastRequestId = 0;
export function hideQuickSearch(setFirstSuggestionAsSearchText = true) {
    return {
        type: HIDE_QUICKSEARCH,
        setFirstSuggestionAsSearchText,
    };
}
export function closeQuickSearch() {
    return {
        type: CLOSE_QUICKSEARCH,
    };
}
export function showQuickSearch() {
    return {
        type: SHOW_QUICKSEARCH,
    };
}
export function showListSearch() {
    return {
        type: SHOW_LISTSEARCH,
    };
}
export function updateSelectedCompletion(index, selectionType) {
    return {
        type: UPDATE_SELECTED_QUICKSEARCH_COMPLETION,
        index,
        selectionType,
    };
}
export function updateQuickSearchCart(code, quantity, unitShortName, ticket) {
    return (dispatch) => {
        dispatch({
            type: UPDATE_QUICKSEARCH_CART,
            code,
            quantity,
            unitShortName,
            ticket,
        });
        return Promise.resolve();
    };
}
export function clearQuickSearchCart() {
    return {
        type: CLEAR_QUICKSEARCH_CART,
    };
}
export function updateQuickSearchText(searchText) {
    return (dispatch) => {
        dispatch({
            type: UPDATE_QUICKSEARCH_TEXT,
            searchText,
        });
    };
}
export function loadQuickSearchRecipes(searchText) {
    const url = recipeOverviewPageUrl().url + "?query=" + searchText;
    return (dispatch) => {
        return server.getJson(url).then((result) => {
            return result && result.list && result.list.recipes;
        });
    };
}
export function loadFilteredQuickSearchRecipes(searchText, recipeId) {
    const url = pathCombine("/RecipeOverviewPage", "/Search?query=" + searchText + "&recipeId=" + recipeId);
    return (dispatch) => {
        return server.getJson(url).then((result) => {
            return result && result.recipes;
        });
    };
}
export function setQuickSearchText(searchText) {
    return (dispatch) => {
        dispatch({
            type: UPDATE_QUICKSEARCH_TEXT,
            searchText,
        });
    };
}
export function loadQuickSearch(searchText) {
    return (dispatch, getState) => {
        const filteredSearchHistory = searchHistory
            .find(searchTextToWords(searchText))
            .filter((s) => s.toLowerCase() !== searchText.toLowerCase())
            .map((s) => ({ text: s }))
            .slice(0, searchHistoryCount);
        dispatch({
            type: UPDATE_QUICKSEARCH_COMPLETIONS,
            lists: [
                {
                    id: SEARCH_HISTORY_LIST_ID,
                    items: filteredSearchHistory,
                },
            ],
        });
        dispatch({
            type: UPDATE_QUICKSEARCH_TEXT,
            searchText,
        });
        const requestId = (lastRequestId = Math.random());
        if (searchText.length > 0) {
            return server
                .get({
                path: pathCombine(searchPageUrl().url, "autocomplete"),
                query: { q: searchText, count: autocompletionCount },
            })
                .then((r) => r.json())
                .then((json) => {
                var _a;
                if (requestId === lastRequestId) {
                    debounceQuickSearchTracking(searchText, json.totalItems, json.products, (_a = getState().appShellData) === null || _a === void 0 ? void 0 : _a.searchApiVariation);
                    cancelPendingViewItemListTracking();
                    var viewItemListEvent = json.trackingData.ga4EventObjects['view_item_list'];
                    dispatch({
                        type: UPDATE_QUICKSEARCH_COMPLETIONS,
                        totalItems: json.totalItems,
                        lists: [
                            {
                                id: POPULAR_SEARCHES_LIST_ID,
                                items: [],
                            },
                            {
                                id: SUGGESTIONS_LIST_ID,
                                items: json.completions,
                                products: json.products,
                                viewItemListEvent,
                                content: json.content,
                                popularSearches: json.popularSearches,
                                searchDidYouMean: json.searchDidYouMean,
                                categorySearchHits: json.categorySearchHits,
                            },
                        ],
                    });
                }
            });
        }
        else {
            return server
                .get({
                path: pathCombine(searchPageUrl().url, "searchsuggestions"),
                query: { q: searchText, count: -1 },
            })
                .then((r) => r.json())
                .then((json) => {
                if (requestId === lastRequestId) {
                    dispatch({
                        type: UPDATE_QUICKSEARCH_COMPLETIONS,
                        lists: [
                            {
                                id: SUGGESTIONS_LIST_ID,
                                items: [],
                            },
                            {
                                id: POPULAR_SEARCHES_LIST_ID,
                                items: json,
                            },
                        ],
                    });
                }
            });
        }
    };
}
export function loadProductSearch(searchText) {
    return (dispatch) => {
        const requestId = (lastRequestId = Math.random());
        if (searchText.length > 0) {
            return server
                .get({
                path: pathCombine(searchPageUrl().url, "autocompletecustom"),
                query: { query: searchText, allowCustom: true, recalcPrice: false },
            })
                .then((r) => r.json())
                .then((json) => {
                if (requestId === lastRequestId) {
                    return json.products;
                }
            });
        }
    };
}
export function searchTextToWords(searchText) {
    return searchText.replace(/\s+/, " ").split(" ");
}
